import {Injectable} from '@angular/core';
import {Group} from 'konva/lib/Group';
import {
    ATTACHMENT_TYPES,
    IGraphNode,
    IIconData,
    ITaskStatusGraphData,
    NODE_STATUSES,
    TAttachmentType,
    TNodeStatus
} from '../models/graph-kn.model-interfaces';
import {Rect, RectConfig} from 'konva/lib/shapes/Rect';
import {Text} from 'konva/lib/shapes/Text';
import {Shape} from 'konva/lib/Shape';
import {KN_ICONS_MAP} from '../models/graph-kn-icons-map';
import {Image} from 'konva/lib/shapes/Image';
import {GraphKnDataService} from './graph-kn.data.service';
import {TranslateService} from '@ngx-translate/core';
import {baseAccent, baseLight, TOOLTIP_BUTTON_COLOR, TOOLTIP_BUTTON_COLOR_TEXT } from '../styles/graph-colors';
import { Vector2d } from 'konva/lib/types';
import { INodeStyleConfing, TEXT_MODEL } from '../models/graph-kn.cm.nodes-model-const';
import { GraphKnHelperService } from './graph-kn.helpers.service';
import { Circle } from 'konva/lib/shapes/Circle';
import { IAttachedInStatusNode } from '../../../models/graph.model';
import { RectModelsMap } from '../styles/graph-node-rect-model';
interface ITooltip  {
    text?: string | undefined;
    offsetX?: number | undefined;
    offsetY?: number | undefined;
    tooltipBackGround?: string | undefined;
}
@Injectable({
    providedIn: 'root'
})
export class GraphKnUIElementsService {
    constructor(
        private knDataService: GraphKnDataService,
        private translateService: TranslateService,
        private graphHelpersService: GraphKnHelperService,
        
    ) {
    }
    createIcon(iconData:IIconData ):Group {
        let iconGroup = new Group({ 
            x: iconData.position.x, 
            y:iconData.position.y 
        })
        iconData.id? iconGroup.id(iconData.id) : null;
        let iconBackGround = new Rect({
            id:'background',
            x:0,
            y:0,
            width:iconData.iconBackGroundHeight,
            height:iconData.iconBackGroundHeight,
            cornerRadius:iconData.iconBackGroundRadius ,
            fill:iconData.iconBackGroundColor,
            stroke:'white',
            strokeWidth:5,
            opacity:1
        })
        iconGroup.add(iconBackGround)
        Image.fromURL(iconData.iconPath, (iconImg) => {
            iconGroup.add(iconImg);
            iconImg.width(iconData.iconHeight)
            iconImg.height(iconData.iconHeight)
    
            iconImg.offsetX(iconData.offsetX);
            iconImg.offsetY(iconData.offsetY);
            iconImg.fill(iconData.iconBackGroundColor)
            let toolTip = iconData.tooltip
            let toolTipGroup = toolTip?.text? this.createIconToolTip(iconImg,toolTip.text,toolTip?.offsetX,toolTip?.offsetY,toolTip.tooltipBackGround) : null
            toolTipGroup? iconGroup.add(toolTipGroup) : null;
            
            iconData.badge? iconGroup.add(this.createIconBadge(iconData)) : null

            if (iconData.activeIcon) {
                iconGroup.on('mouseenter',()=>this.togglePointer('pointer'))
                iconGroup.on('mouseleave',()=>this.togglePointer('default'))
            } 
        })
        return iconGroup
    }
    togglePointer(cursorType:'pointer'|'default') {
		let stageContainer = this.knDataService.graphStage.container()
		stageContainer.style.cursor = cursorType
	}
    createIconToolTip (iconImg:Image,tooltipText:string,offsetX?:number,offsetY?:number, tooltipBackGround?:string):Group {
        let tooltip = this.createToolTip(iconImg, tooltipText, 14, 1, tooltipBackGround, offsetY,offsetX);
        iconImg.on('mouseover', () => tooltip.group.show())
        iconImg.on('mouseout', () => tooltip.group.hide())
        return tooltip.group
    }
    createIconBadge(iconData:IIconData):Group {
        let badgeGroup = new Group ({
            id:'badge'
        })
        badgeGroup.add(new Circle({
            radius:7,
            fill:baseAccent,
            offsetX:-7,
            offsetY:-6,
        }))
        badgeGroup.add(new Text({
            text:iconData.badge?.qty,
            fill:baseLight,
            fontSize:12,
            offsetX:-4 ,
            offsetY:-1,
            fontFamily:'Onest'
        }))
        return badgeGroup

    }
    createStatusPanel(nodeGroup: Group, node: IGraphNode, rectModel:RectConfig, typedNodeCSS: INodeStyleConfing) {
        let statusData = this.graphHelpersService.getStatusData(node)
        let keysToIcons = [...ATTACHMENT_TYPES, ...NODE_STATUSES]
        let cssStatusPanel = typedNodeCSS.statusPanel
        let iconQty:number = 0
        let statusGroup = new Group({
          x : cssStatusPanel.offsetX * (rectModel.width!),
          y : cssStatusPanel.offsetY * (rectModel.height!),
          height:cssStatusPanel.height *  ( rectModel.height!),
          width:cssStatusPanel.width *  ( rectModel.width!)
        })
        nodeGroup.add(statusGroup)
        let rect= new Rect({
          x:0,
          y:0,
          //stroke:'red',
          cornerRadius:2,
          strokeWidth:1,
          height:30,
          width:cssStatusPanel.width *  (rectModel.width!)
        })
        statusGroup.add(rect)
        if (statusData?.data?.svg?.class) {
            let iconPath = '../../../../assets/icons/' + statusData?.data?.svg.class + '.svg'
            this.createStatusIcon(statusGroup,iconPath,typedNodeCSS,iconQty)
            iconQty += 1
        }
                    
        for (const key in statusData) {
            let icon = KN_ICONS_MAP.get(key as unknown as TNodeStatus)
            if (keysToIcons.includes(key as unknown as TNodeStatus | TAttachmentType) && (statusData as any)[key] && icon) {
                let tooltip = {
                    text:this.translateService.instant('GRAPH.STATUS_ICONS.' + key),
                    offsetX:0,
                    offsetY:30,
                    tooltipBackGround:cssStatusPanel.tooltip.backGround
                }
                this.createStatusIcon(statusGroup,icon.path,typedNodeCSS,iconQty,tooltip)
                iconQty += 1
            }
        }
        let taskData = statusData as ITaskStatusGraphData
        let attachedFiles = taskData?.attachments?.filter(el=>el.attachment_type ==='file')
        let attachedPhotos = taskData?.attachments?.filter(el=>el.attachment_type ==='photo')
        let tooltip = {
            text:'',
            offsetX:0,
            offsetY:cssStatusPanel.iconRadius,
            tooltipBackGround:cssStatusPanel.tooltip.backGround
        }
        if (taskData?.attachments?.length && attachedFiles.length) {
            let icon = KN_ICONS_MAP.get('attachments_files')!
            let tooltipFiles = structuredClone({...tooltip, text: 'Документы - файлы'})
            let attachGroup = 
            this.createStatusIcon(statusGroup,icon.path,typedNodeCSS,iconQty,tooltipFiles, (attachedFiles.length).toString())
            iconQty += 1;
            this.addAttachmentsIconEmitter(attachGroup,attachedFiles,'file',taskData.task_alias)
        }
        if (taskData?.attachments?.length && attachedPhotos.length) {
            let icon = KN_ICONS_MAP.get('attachments_images')!
            tooltip.text = 'Документы - изображения'
            let attachGroup = 
            this.createStatusIcon(statusGroup,icon.path,typedNodeCSS,iconQty,tooltip,(attachedPhotos.length).toString())
            this.addAttachmentsIconEmitter(attachGroup,attachedPhotos,'photo',taskData.task_alias)
            iconQty += 1
        }
    }
    createStatusIcon(
        statusGroup:Group, iconPath:string, typedNodeCSS: INodeStyleConfing, 
        iconQty:number, tooltip?:ITooltip, badge?:string
    ) :Group {
        let cssStatusPanel = typedNodeCSS.statusPanel
        let iconNodeData:IIconData = {
            iconPath:iconPath,
            position:{
                x: (cssStatusPanel.iconRadius * 2 + cssStatusPanel.gap) * iconQty,
                y: 0
            },
            iconHeight:cssStatusPanel.iconHeight,
            iconBackGroundHeight:cssStatusPanel.iconBackGroundHeight,
            iconBackGroundRadius:cssStatusPanel.iconBackGroundHeight,
            iconBackGroundColor:cssStatusPanel.iconBackGround,
            offsetX:(cssStatusPanel.iconHeight - cssStatusPanel.iconBackGroundHeight)/2,
            offsetY:(cssStatusPanel.iconHeight - cssStatusPanel.iconBackGroundHeight)/2,
            tooltip:tooltip,
            badge:badge? {qty:badge} : undefined,
            activeIcon:!!badge
        }
        let iconGroup = this.createIcon(iconNodeData)
        statusGroup.add(iconGroup)
        return iconGroup
    }
    addAttachmentsIconEmitter(group:Group, attachedObjs:IAttachedInStatusNode[], attachType:'file'|'photo',task_alias:string) {
        group.on('click',(event=>{
            event.cancelBubble = true
            let stageRect = this.knDataService.graphStage.container().getBoundingClientRect()
            let backgroundRect = group.children.find(el=>el.attrs?.id==='background') as Rect
            this.knDataService.subAttachementsListOpen.next({
                visibility:'visible',
                left:group.getAbsolutePosition().x + stageRect.left - 100,
                top:group.getAbsolutePosition().y + backgroundRect?.height() + stageRect.top + 20,
                data:attachedObjs,
                attachType:attachType,
                task_alias:task_alias
            })
        }))
    }
    calcDeleteButtonPostion(points:number[],cssConfig:INodeStyleConfing):Vector2d {
      let cssDeleteButton = cssConfig.edgeDeletButton
      let dx = points[2] - points[0]
      let dy = points[3] - points[1]
      let xPos:number = 0
      xPos =  dx> 0? points[0] + cssDeleteButton.iconBackGroundHeight/2 : points[0] - cssDeleteButton.iconBackGroundHeight*1.5
      let result:Vector2d = {
        x:xPos,
        y:dy / dx * cssDeleteButton.iconBackGroundHeight + points[1] - cssDeleteButton.iconBackGroundHeight/2 
      }
      return result
    }
    createToolTip(button: Shape, labelCode: string, baseFontSize: number, opacity?: number, backGround?: string, offsetY = 0, offsetX = 0): {
        button: Rect,
        group: Group
    } {
        const tooltipPadding = {
            top:10,
            bottom:10,
            left:10,
            right:10
        }
        const tooltipWidth = 200
        let tooltipGroup = new Group({
            id:'tooltipGroup',
            y: button.height()  + offsetY,
            visible: false,
        })
        labelCode = this.translateService.instant(labelCode) || labelCode;
        const tooltip = new Text({
            ...TEXT_MODEL,
            opacity: opacity || 0.6,
            width: tooltipWidth,
            text: labelCode,
            verticalAlign: 'middle',
            fill: TOOLTIP_BUTTON_COLOR_TEXT,
            align: 'center',
            fontSize: baseFontSize,
            
        });
        let textWidth = tooltip.measureSize(labelCode)
        tooltip.width(textWidth.width )
        tooltip.height(textWidth.height + tooltipPadding.top + tooltipPadding.bottom)
        let buttonRect = new Rect({
            fill: backGround || TOOLTIP_BUTTON_COLOR,
            width: textWidth.width  +  tooltipPadding.left + tooltipPadding.right,
            height: textWidth.height + tooltipPadding.top + tooltipPadding.bottom,
            opacity: opacity || 0.4,
            cornerRadius:12
        })
        tooltipGroup.add(buttonRect)
        tooltipGroup.add(tooltip)
        return {button: buttonRect, group: tooltipGroup}
    }
    createLoadingState(nodeGroup: Group, nodeId: string) {
        nodeGroup.add(new Text({
            ...TEXT_MODEL,
            id: nodeId + 'load',
            text: this.translateService.instant('BUTTON_TEXT.LOADING'),
            verticalAlign: 'bottom',
            align:'center',
            width: (nodeGroup.attrs?.dimensions?.width),
            height:  (nodeGroup.attrs?.dimensions?.height) - 10,
        }))
    }
}